import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { indicadoresVivosModulo } from '../diccionarios/indicadoresVivosModulo';

@Injectable({
  providedIn: 'root'
})
export class DireccionesService {

  diccionarioUrl: any;
  urlDistribuidor: string;
  urlPresupuestoComercial: string;
  constructor(
    private commom: CommonService,
    private utilServices: UtilsService
  ) {
    this.urlDistribuidor = this.utilServices.getDistribuidor();
    this.urlPresupuestoComercial = this.utilServices.getPresupuestoComercial();
    this.diccionarioUrl = indicadoresVivosModulo.url.indicadores;
  }

  getDirecciones() {
    return this.commom.peticionGetConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.direcciones);
  }

  saveDirecciones(innObj: any) {
    return this.commom.peticionPostConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.direcciones, innObj);
  }

  updateDirecciones(innObj: any) {
    return this.commom.peticionPutConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.direcciones, innObj);
  }

  deleteDirecciones(innIdDireccion: string) {
    return this.commom.peticionDeleteConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.direcciones+ `/${innIdDireccion}`);
  }
}
